<template>
    <div class="page_title_area">
        岗位管理
    </div>
</template>
<script>
import mixins from "./Mixins";
export default {
mixins:[mixins],
mounted(){
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(2);
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/PartI/PermissionPackage/components/pmsTitle.vue